import Router from "@/common/router/Router";

export default class WorkPeriodRouter extends Router {
  static BASE_PATH = "/wpt";
  static SHOW_ROUTE_NAME = "work-period-template-show";
  static CREATE_ROUTE_NAME = "work-period-template-create";
  static UPDATE_ROUTE_NAME = "work-period-template-update";
  static LIST_ROUTE_NAME = "work-period-template-list";
  private static _instance: WorkPeriodRouter;
  public static instance(): WorkPeriodRouter {
    if (!WorkPeriodRouter._instance) {
      WorkPeriodRouter._instance = new WorkPeriodRouter();
    }
    return WorkPeriodRouter._instance;
  }

  private constructor() {
    super(
      WorkPeriodRouter.BASE_PATH,
      WorkPeriodRouter.SHOW_ROUTE_NAME,
      WorkPeriodRouter.CREATE_ROUTE_NAME,
      WorkPeriodRouter.UPDATE_ROUTE_NAME,
      WorkPeriodRouter.LIST_ROUTE_NAME
    );
  }
}
